import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from 'yup';

export interface IDocumentNameFormValues {
  name: string;
}

export const toFileName = (draft: string, extension: string): string =>
  `${draft.trim()}${extension}`;

export const getDocumentNameResolver = (
  extension: string,
  getError: (fileName: string) => string | null,
) =>
  yupResolver(
    object({
      name: string().test('file-name', (draft, { createError }) => {
        const message = getError(toFileName(draft ?? '', extension));
        return message ? createError({ message }) : true;
      }),
    }),
  );
